import React from "react";
import { ChartBar, Scales } from "@phosphor-icons/react";

export default function MathView({ issues, updateIssue, combined }) {
  return (
    <div className="view-grid" data-testid="math-view">
      <div className="panel" data-testid="math-summary-panel">
        <div className="panel-header">
          <ChartBar size={18} weight="bold" />
          <span>VA MATH & BILATERAL FACTOR</span>
        </div>
        <div className="panel-body">
          <div className="math-summary" data-testid="math-summary">
            <div className="math-metric" data-testid="math-rounded">
              <div className="math-metric-value mono">{combined.rounded}%</div>
              <div className="math-metric-label">ROUNDED EST.</div>
            </div>
            <div className="math-metric" data-testid="math-raw">
              <div className="math-metric-value mono">{combined.raw}%</div>
              <div className="math-metric-label">RAW COMBINED</div>
            </div>
            <div className="math-metric" data-testid="math-bilateral">
              <div className={`math-metric-value mono ${combined.bilateralApplied ? "text-accent" : ""}`}>{combined.bilateralApplied ? "YES" : "NO"}</div>
              <div className="math-metric-label">BILATERAL</div>
            </div>
            {combined.bilateralApplied && (
              <>
                <div className="math-metric" data-testid="math-bilateral-base">
                  <div className="math-metric-value mono">{combined.bilateralBase}%</div>
                  <div className="math-metric-label">BILATERAL BASE</div>
                </div>
                <div className="math-metric" data-testid="math-bilateral-added">
                  <div className="math-metric-value mono">+{combined.bilateralAdded}%</div>
                  <div className="math-metric-label">10% FACTOR</div>
                </div>
              </>
            )}
          </div>
          <div className="math-explain" data-testid="math-explain">
            <p>VA uses progressive combination (38 CFR 4.25). Each rating applies to remaining disability, not total. Bilateral factor adds 10% to eligible paired extremity ratings before final combination.</p>
          </div>
        </div>
      </div>

      {[...issues].sort((a, b) => (a.claimedAs || "").localeCompare(b.claimedAs || "")).map((issue) => (
        <div key={issue.id} className="panel" data-testid={`math-issue-${issue.id}`}>
          <div className="panel-header">
            <Scales size={16} weight="bold" />
            <span>{issue.claimedAs}</span>
            <span className="header-count mono">{issue.estimatedRating || 0}%</span>
          </div>
          <div className="panel-body">
            <div className="math-issue-fields">
              <label className="field">
                <span className="field-label">RATING</span>
                <select className="field-input mono" value={issue.estimatedRating || 0} onChange={(e) => updateIssue(issue.id, { estimatedRating: Number(e.target.value) })} data-testid={`math-rating-${issue.id}`}>
                  {[0,10,20,30,40,50,60,70,80,90,100].map((r) => <option key={r} value={r}>{r}%</option>)}
                </select>
              </label>
              <label className="field">
                <span className="field-label">SIDE</span>
                <select className="field-input" value={issue.bilateralSide || "Not applicable"} onChange={(e) => updateIssue(issue.id, { bilateralSide: e.target.value })} data-testid={`math-side-${issue.id}`}>
                  <option>Not applicable</option>
                  <option>Left</option>
                  <option>Right</option>
                  <option>Bilateral</option>
                </select>
              </label>
              <label className="field">
                <span className="field-label">PAIRED GROUP</span>
                <select className="field-input" value={issue.pairedExtremity || "None"} onChange={(e) => updateIssue(issue.id, { pairedExtremity: e.target.value })} data-testid={`math-paired-${issue.id}`}>
                  <option>None</option>
                  <option>Upper extremities</option>
                  <option>Lower extremities</option>
                  <option>Paired skeletal muscles</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
